const COUNTRY_CODE: {
  [key: string]: string;
} = {
  US: 'US',
};

export const validatePhoneNumber = (
  phoneNumber: string,
  countryCode: string,
): boolean => {
  let valid = true;
  phoneNumber = phoneNumber.replace(/[.()+ -]/gi, '');
  if (countryCode === COUNTRY_CODE.US) {
    // US phone number should start with 1 with 10 digits following
    if (!/^1?\d{10}$/.test(phoneNumber)) {
      valid = false;
    }
  } else if (!/^\d+$/.test(phoneNumber)) {
    valid = false;
  }
  return valid;
};

export const normalizePhoneNumber = (phoneNumber: string): string =>
  phoneNumber.replace(/[^0-9]/gi, '');
